import "./../styles.css";
import letterHeadLeft from "../../../imgs/letter-head-left.png";
import letterHeadRight from "../../../imgs/letter-head-right.jpeg";
import footer from "../../../imgs/footer.png";
import "./style.css";

const PrintComponent = ({ children }) => {

  return (
    <>
      <div className="page-header no-print-background">
        <div className="d-flex align-items-center justify-content-between p-0 w-100">
          <div className="header-left-image">
             <img src={letterHeadLeft} height={80} style={{ objectFit: 'contain' }} />
          </div>
          <div className="header-right-image">
             <img src={letterHeadRight} height={80} style={{ objectFit: 'contain' }} />
          </div>
        </div>
      </div>

      <div className="page-footer">
        <div style={{ position: 'relative' }}>
          <img src={footer} height={160} style={{ width: "100%", objectFit: 'cover' }} />
          <div style={{ 
            position: 'absolute', 
            bottom: '40px', 
            left: '0', 
            right: '0', 
            textAlign: 'center',
            fontSize: '8pt',
            color: 'white',
            fontWeight: 500,
            opacity: 0.9
          }}>
             {/* Dynamic page numbers or copyright could go here */}
          </div>
        </div>
      </div>

      <div className="print-component" id="print-component">
        <table>
          <thead>
            <tr>
              <td>
                <div className="page-header-space"></div>
              </td>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td>
                <div className="page">{children}</div>
              </td>
            </tr>
          </tbody>

          <tfoot>
            <tr>
              <td>
                <div className="page-footer-space"></div>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </>
  );
};

export default PrintComponent;
